import React from 'react';
import styles from './ClinicsMap.module.scss';
import GoogleMapReact from 'google-map-react';
import { IoLocationSharp } from 'react-icons/io5';
import _ from 'lodash';
import { $t } from "helpers/translator";
import api from "helpers/api";


class DashboardChainClinicsMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clinics: [],
            clinicsWithLocation: [],

            defaultCenter: {
                lat: 32.48,
                lng: 34.94
            },
            defaultZoom: 7,

            center: {
                lat: 32.48,
                lng: 34.94
            },
            zoom: props.zoom ? props.zoom : 7,

            clinicSelected: null
        };
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        let res = null;
        try {
            res = await api.get('dashboard/clinics/graph');
            let clinicsWithLocation = [];

            let lat = {
                max: null,
                center: null,
                min: null
            };
            let lng = {
                max: null,
                center: null,
                min: null
            };

            if (!res) {
                return;
            }

            _.forEach(res.data.data, (v, k) => {
                lat.min = v.lat && (!lat.min || v.lat < lat.min) ? v.lat : lat.min;
                lat.max = v.lat && (!lat.max || v.lat > lat.max) ? v.lat : lat.max;
                lng.min = v.long && (!lng.min || v.long < lng.min) ? v.long : lng.min;
                lng.max = v.long && (!lng.max || v.long > lng.max) ? v.long : lng.max;
                v.location = false;

                if (v.lat && v.long) {
                    v.location = true;
                    clinicsWithLocation.push(v);
                }
            });

            lat.center = lat.max && lat.min ? (lat.max + lat.min) / 2 : 30;
            lng.center = lng.max && lng.min ? (lng.max + lng.min) / 2 : 30;

            if (res && res.data && res.data.data) {
                this.setState({
                    clinics: res.data.data,
                    clinicsWithLocation: clinicsWithLocation,
                    center: clinicsWithLocation && clinicsWithLocation.length ? null : {
                        lat: lat.center,
                        lng: lng.center
                    }
                }, () => {
                    // console.log('clinics after  update:', this.state);
                    if (clinicsWithLocation && clinicsWithLocation.length) {
                        this.clinicSelectedHandler(clinicsWithLocation[ 0 ]);
                    }
                });

            }
        } catch (e) {
            console.error('clinics on map errp', e);
        }
    }

    clinicSelectedHandler(clinic) {
        let defaultCenter = { ...this.state.defaultCenter }
        if (this.state.center && defaultCenter.lat === this.state.center.lat && defaultCenter.lng === this.state.center.lng) {
            defaultCenter.lat = defaultCenter.lat - 0.01;
        }

        if (this.state.clinicSelected && clinic.id === this.state.clinicSelected.id) {
            this.setState({
                center: defaultCenter,
                zoom: this.state.defaultZoom,
                clinicSelected: null,
            });
        } else {
            if (!clinic.lat || !clinic.long) {
                this.setState({
                    clinicSelected: clinic,
                    center: defaultCenter,
                    zoom: this.state.defaultZoom,
                });
            } else {
                this.setState({
                    center: {
                        lat: clinic.lat,
                        lng: clinic.long
                    },
                    zoom: 6,
                    clinicSelected: clinic
                });
            }
        }
    }

    mapClickHandler() {
        this.setState({
            center: null,
            clinicSelected: null
        });
    }

    renderMap() {
        let clinicsWithLocation = this.state.clinicsWithLocation;
        return (
            <div className={ `${styles.mapWrapper}` }>
                <GoogleMapReact
                    bootstrapURLKeys={ { key: 'AIzaSyBjywQFrNLLJaQNzbW_U2xY5A2hkB6Aweg' } }
                    defaultCenter={ this.state.defaultCenter }
                    center={ this.state.center }
                    defaultZoom={ this.state.defaultZoom }
                    zoom={ this.state.zoom }
                    yesIWantToUseGoogleMapApiInternals
                    onClick={ () => this.mapClickHandler() }
                // onCenterChange={() => console.log('a')} // @controllable generated fn
                // onZoomChange={() => console.log('a')} // @controllable generated fn
                >
                    { clinicsWithLocation.map((v) => {
                        return (
                            <div className={ `${styles.mapMarkerContainer}` }
                                key={ v.id }
                                lat={ v.lat }
                                lng={ v.long }>

                                <IoLocationSharp className={ `${styles.mapMarker}` } onClick={ () => this.clinicSelectedHandler(v) } />
                                <div
                                    className={ `${styles.mapMarkerDetails} ${this.state.clinicSelected && this.state.clinicSelected.id === v.id ? styles.displayBlock : ''}` }>
                                    <div>{ $t('global.chainDashboard.clinicName') }: { v.clinic_name }</div>
                                    <div>{ $t('global.chainDashboard.clinicNumber') }: { v.clinic_number ? v.clinic_number : '-' }</div>
                                    <div>{ $t('global.chainDashboard.platforms') }: { v.machines ? v.machines : 0 }</div>
                                    <div>{ $t('global.chainDashboard.patients') }: { v.patients ? v.patients : 0 }</div>
                                    <div>{ $t('global.chainDashboard.staffMembers') }: { v.staffs ? v.staffs : 0 }</div>
                                </div>
                            </div>
                        );
                    }
                    ) }
                </GoogleMapReact>
                <React.Fragment>
                    { this.state.clinicSelected && !this.state.clinicSelected.location ?
                        <div
                            className={ `${styles.mapMarkerDetails} ${styles.displayBlock} ${styles.noLocationClinicDetails}` }>
                            <div>{ $t('global.chainDashboard.clinicName') }: { this.state.clinicSelected.clinic_name }</div>
                            <div>{ $t('global.chainDashboard.clinicNumber') }: { this.state.clinicSelected.clinic_number ? this.state.clinicSelected.clinic_number : '-' }</div>
                            <div>{ $t('global.chainDashboard.platforms') }: { this.state.clinicSelected.machines ? this.state.clinicSelected.machines : 0 }</div>
                            <div>{ $t('global.chainDashboard.patients') }: { this.state.clinicSelected.patients ? this.state.clinicSelected.patients : 0 }</div>
                            <div>{ $t('global.chainDashboard.staffMembers') }: { this.state.clinicSelected.staffs ? this.state.clinicSelected.staffs : 0 }</div>
                            <div className={ `${styles.noLocationTag}` }>{ $t('global.chainDashboard.noLocationFound') }</div>
                        </div>
                        :
                        null
                    }
                </React.Fragment>
            </div>
        );
    }

    renderList() {
        let clinics = this.state.clinics;

        return (
            <div>
                { clinics.map((v) => {
                    return (
                        <div
                            className={ `${styles.listItemContainer} ${this.state.clinicSelected && this.state.clinicSelected.id === v.id ? styles.selectedClinicName : ''}` }
                            key={ v.id }
                            onClick={ () => this.clinicSelectedHandler(v) }
                        >
                            { v.clinic_name }
                        </div>
                    );
                }
                ) }
            </div>
        );
    }

    render() {
        return (
            <div className={ `${styles.containerIn}` }>
                <div className={ `${styles.mapContainer}` }>
                    { this.renderMap() }
                </div>
                {
                    this.state.clinics && this.state.clinics.length ?
                        <div className={ `${styles.clinicsListContainer}` } style={ { maxHeight: this.props.maxHeight ? `${this.props.maxHeight}` : 'auto' } }>
                            { this.renderList() }
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}

export default DashboardChainClinicsMap;
